import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { ScreenFrame, ListCard, EmptyState, ViewToggle } from '../PrototypeShared';
import { Inventory } from '@mui/icons-material';

const MOCK_PALLETS = [
  { id: 'P001', location: 'A-1', status: 'Available' },
  { id: 'P002', location: 'A-2', status: 'In production' },
];

export default function PalletsScreen() {
  const navigate = useNavigate();
  const [view, setView] = useState('list');

  return (
    <ScreenFrame
      title="Pallets"
      actions={
        <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
      }
    >
      {view === 'empty' && (
        <EmptyState icon={Inventory} title="No pallets" description="No pallets in the system." actionLabel="Incoming stock" onAction={() => navigate('/prototype/incoming-deliveries/stock')} />
      )}
      {view === 'list' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {MOCK_PALLETS.map((p) => (
            <ListCard key={p.id} title={`Pallet ${p.id}`} subtitle={p.location} status={p.status} to={`/prototype/pallets/${p.id}`} />
          ))}
        </Box>
      )}
    </ScreenFrame>
  );
}
